import mixpanel from "./mixpanel.config";
import type { ITrackClaraConversationStartedParams } from "./track-clara-conversation-started.interface";

export const CLARA_CONVERSATION_STARTED_EVENT_NAME = "clara_conversation_started";

export function trackClaraConversationStarted(params: ITrackClaraConversationStartedParams): void {
  const { accountId, email, conversationId, userTierAtEvent, entryPoint } = params;

  mixpanel.track(CLARA_CONVERSATION_STARTED_EVENT_NAME, {
    distinct_id: accountId,
    email,
    conversationId,
    userTierAtEvent,
    entryPoint,
  });
}
